import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { processSessionId } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    const processAuth = async () => {
      // Get session_id from URL hash
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.replace('#', ''));
      const sessionId = params.get('session_id');

      if (sessionId) {
        try {
          const result = await processSessionId(sessionId);
          
          if (result.success) {
            // Clear the hash and redirect
            window.history.replaceState(null, '', window.location.pathname);
            navigate('/dashboard', { replace: true });
          } else {
            setError(result.error || 'Authentication failed. Please try again.');
          }
        } catch (err) {
          setError('Authentication failed. Please try again.');
        }
      } else {
        // No session_id, redirect to login
        navigate('/login', { replace: true });
      }
    };

    processAuth();
  }, [navigate, processSessionId]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <p className="text-red-600 mb-4">{error}</p>
          <button
            onClick={() => navigate('/login')}
            className="text-emerald-700 hover:underline"
          >
            Return to login
          </button>
        </div>
      </div>
    );
  }

  return null; // Silent processing, no loading UI
};

export default AuthCallback;
